import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import MarqueeRibbon from "@/components/site/MarqueeRibbon";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import ChatWidget from "@/components/site/ChatWidget";
import AdminUpload from "@/pages/AdminUpload";
import MediaRibbon, { KITCHEN_PHOTOS, SPACE_PHOTOS } from "@/components/site/MediaRibbon";
import { LightboxProvider } from "@/components/site/Lightbox";

const HomePage = () => (
  <div className="bg-paper text-ink font-sans antialiased overflow-x-clip">
    <Navbar />
    <main>
      <Hero />
      <MarqueeRibbon />
      <Services />
      <MediaRibbon
        photos={KITCHEN_PHOTOS}
        label="Our recent kitchens — straight from site"
        testId="media-ribbon"
      />
      <Manifesto />
      <Gallery />
      <MediaRibbon
        photos={SPACE_PHOTOS}
        label="Wardrobes & living spaces — built by us"
        testId="space-ribbon"
        direction="right"
      />
      <Reviews />
      <Contact />
    </main>
    <Footer />
    <WhatsAppButton />
    <ChatWidget />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <LightboxProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/studio-admin" element={<AdminUpload />} />
          </Routes>
        </LightboxProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-left"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#FDFBF7",
            border: "1px solid #E5DFD5",
            borderRadius: "0",
          },
        }}
      />
    </>
  );
}

export default App;
